import React, { useEffect, useRef, useState } from "react";
import { FcCloseUpMode } from "react-icons/fc";

const YardWiseSummery = ({ data }) => {
  const tableHead = [
    "Sno",
    "reportDate",
    "From_Station",
    "To_Station",
    "Type",
    "Block_Type",
    "No_Of_Demand_By_Engg",
    "Engg_Demand",
    "No_Of_Demand_Agreed_GIVEN",
    "Agreed_Demand",
    "GrantedFrom",
    "GrantedTo",
    "Granted_Duration",
    "Availed_From",
    "Availed_To",
    "Availed",
  ];
  const tableRef = useRef();
  const [yardStation, setYardStation] = useState("JABALPUR JN.");
  const [tableData, setTableData] = useState("");

  //   console.log(yardStation);
  useEffect(() => {
    const filData = data.filter((o) => o.Section_Yard === "Yard");
    const fd2 = filData.filter(
      (o) => o.From_Station == yardStation && o.To_Station == yardStation,
    );
    setTableData(fd2);
  }, [yardStation, data]);
  //   console.log(tableData);

  return (
    <div className="papaDiv">
      <div className="bg-dark text-white p-3 d-flex justify-content-between">
        <h1></h1>
        <h5>Yard Wise Summary</h5>
        <select
          className="form-select form-control text-center fw-bold"
          style={{ maxWidth: "150px" }}
          value={yardStation}
          onChange={(e) => setYardStation(e.target.value)}
        >
          <option value="JABALPUR JN.">JABALPUR JN.</option>
          <option value="SATNA JN.">SATNA JN.</option>
          <option value="NEW KATNI JN.">NEW KATNI JN.</option>
        </select>
      </div>

      {(data && data.length > 0) || <div>No Data Found</div>}
      {data && data.length > 0 && (
        <div
          className="table-responsive "
          style={{ maxHeight: "600px", overflow: "auto" }}
        >
          <table
            className="table table-hover table-striped "
            ref={tableRef}
            style={{ fontSize: "13px" }}
          >
            <thead className="sticky-top table-dark" style={{ zIndex: 2 }}>
              <tr>
                {tableHead.map((head, i) => {
                  return (
                    <th key={i} className="text-wrap align-middle">
                      {head}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {tableData &&
                tableData.map((obj, ind) => (
                  <tr key={ind}>
                    <td>{ind + 1}</td>
                    <td>{obj.reportDate}</td>
                    <td>{obj.From_Station}</td>
                    <td>{obj.To_Station}</td>
                    <td>{obj.Type}</td>
                    <td>{obj.Block_Type}</td>
                    <td>{obj.No_Of_Demand_By_Engg}</td>
                    <td>{obj.Engg_Demand}</td>
                    <td>{obj.No_Of_Demand_Agreed_GIVEN}</td>
                    <td>{obj.Agreed_Demand}</td>
                    <td>{obj.GrantedFrom}</td>
                    <td>{obj.GrantedTo}</td>
                    <td>{obj.Granted_Duration}</td> <td>{obj.Availed_From}</td>
                    <td>{obj.Availed_To}</td>
                    <td>{obj.Availed}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default YardWiseSummery;
